import axios from 'axios'
import { resolveFrontendApiBase } from './apiBase';

const API_BASE = resolveFrontendApiBase()

type PricingIntentPayload = {
  anonymousFunnelId: string
  planKey: string
  source?: string | null
  surface: string
  isForeverCredits?: boolean
}

const randomId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `rh_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
}

export const generateRevenueFunnelId = (): string => `rhf_${randomId()}`

export const trackRevenuePricingIntent = async ({
  anonymousFunnelId,
  planKey,
  source,
  surface,
  isForeverCredits = false,
}: PricingIntentPayload): Promise<void> => {
  await axios.post(`${API_BASE}/revenue-health/pricing-intent`, {
    anonymousFunnelId,
    planKey,
    source: source || null,
    surface,
    isForeverCredits,
    occurredAt: new Date().toISOString(),
  })
}

